<script setup>
const pt = {
  message: '',
}

const severityClass = ref({
  success: 'bg-dss-success-100 border-l-[6px] border-dss-success-600 text-dss-success-600',
  warning: 'bg-dss-warning-100 border-l-[6px] border-dss-warning-600 text-dss-warning-600',
  error: 'bg-dss-error-100 border-l-[6px] border-dss-error-600 text-dss-error-600',
  info: 'bg-dss-info-100 border-l-[6px] border-dss-info-600 text-dss-info-600',
})

const severityIcon = ref({
  success: 'pi pi-check',
  warning: 'pi pi-exclamation-triangle',
  error: 'pi pi-times-circle',
  info: 'pi pi-info-circle',
})
</script>

<template>
  <Toast
    :pt
    position="top-center"
    close-icon="h-5 w-5 pi-times"
  >
    <template #container="{ message, closeCallback }">
      <div
        class="w-180 py-5 px-6 mb-2 text-sm flex items-center gap-2"
        :class="severityClass[message.severity]"
      >
        <i
          class="text-lg mr-2"
          :class="severityIcon[message.severity]"
        />
        <div class="flex-1">
          <span class="font-bold mr-2">{{ message.summary }}</span>{{ message.detail }}
        </div>
        <button
          v-if="message.action"
          class="underline underline-offset-2 font-semibold whitespace-nowrap transition-colors hover:brightness-75"
          @click="message.action.onClick(closeCallback)"
        >
          {{ message.action.label }}
        </button>
        <button
          class="rounded-full transition-colors hover:brightness-50"
          @click="closeCallback"
        >
          <i class="pi pi-times text-lg" />
        </button>
      </div>
    </template>
  </Toast>
</template>
